import { render, staticRenderFns } from "./AlertsHistory.vue?vue&type=template&id=0b8fc72e&"
import script from "./AlertsHistory.vue?vue&type=script&lang=js&"
export * from "./AlertsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8fc72e')) {
      api.createRecord('0b8fc72e', component.options)
    } else {
      api.reload('0b8fc72e', component.options)
    }
    module.hot.accept("./AlertsHistory.vue?vue&type=template&id=0b8fc72e&", function () {
      api.rerender('0b8fc72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/alerts/AlertsHistory.vue"
export default component.exports